import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import MaterialIcon from 'site-react/core/Icon/MaterialIcon';
import Paragraph from 'site-react/core/Paragraph';
import theme from 'site-react/theme';

const closeButtonStyle = css`
  background: none;
  color: ${theme.colors.white};
  cursor: pointer;
  flex: 0;
`;

const closeIconStyle = css`
  display: block;
  font-size: ${theme.spacing.lg}px;
`;

const contentStyle = css`
  flex: 1;
  margin-right: ${theme.spacing.sm}px;
`;

const iconStyle = css`
  display: block;
  flex: 0;
  font-size: ${theme.spacing.lg}px;
  margin-right: ${theme.spacing.sm}px;
`;

const wrapperStyle = css`
  align-items: center;
  animation: ${theme.animation.pop} ${theme.animation.timings.medium}
    ease-in-out;
  background-color: ${theme.colors.error};
  color: ${theme.colors.white};
  display: flex;
  margin: 0 auto;
  max-width: ${theme.grid.maxWidth}px;
  padding: ${theme.spacing.md}px;
  pointer-events: auto;
  width: 100%;
`;

const ErrorToast = ({ children, onClose }) => (
  <div className={wrapperStyle} data-testid="ErrorToast">
    <MaterialIcon iconType="error" className={iconStyle} />

    <div aria-live="polite" className={contentStyle}>
      <Paragraph>{children}</Paragraph>
    </div>

    <button
      className={closeButtonStyle}
      data-testid="ErrorToast-closeButton"
      onClick={onClose}
      type="button"
    >
      <MaterialIcon iconType="close" className={closeIconStyle} />
    </button>
  </div>
);

ErrorToast.propTypes = {
  /**
   * Text to show inside the toast
   */
  children: PropTypes.node.isRequired,

  /**
   * Callback when the close button is clicked
   */
  onClose: PropTypes.func.isRequired,
};

export default ErrorToast;
